(function (electivesFilterApp) {
    $(document).on("change", "#elective-year-filter", function (e) {
        e.preventDefault();
        const year = $(this).val();        
        const pageId = $(this).data("pageid");
        $.ajax({
            url: `/umbraco/surface/ElectivesSurface/GetFilterResult?year=${year}&id=${pageId}`,
            type: "GET",
            dataType: "html",
            success: function (data) {
                console.log(data)
                $('.electives-list').html(data);
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    });
})();
